import {
    FETCH_CUSTOMERS_STARTED,
    FETCH_CUSTOMERS_SUCCESS,
    CANCEL_SUBSCRIPTION_STARTED,
    CANCEL_SUBSCRIPTION_SUCCESS,
    FETCH_INVOICES_SUCCESS,
    FETCH_INVOICES_STARTED,
    CUSTOMERS_FETCHED_STATUS,
    INVOICES_FETCHED_STATUS,
  } from "../actionTypeConstants/constants";
  import axios from "axios";
  import { baseUrl } from "../../environments/environment";
  import { toast } from "react-toastify";
  import { getAccessToken } from "../../helpers/genericHelpers";

  
  export const setIsCustomersFetchStarted = (status) => {
    const action = {
      type: FETCH_CUSTOMERS_STARTED,
      payload: {
        status,
      },
    };
    return action;
  };

  export const setIsCustomersFetched = (status) => {
    const action = {
      type: CUSTOMERS_FETCHED_STATUS,
      payload: {
        status,
      },
    };
    return action;
  };
  
  export const fetchCustomersSuccess = (data, offset, limit) => {
    const action = {
      type: FETCH_CUSTOMERS_SUCCESS,
      payload: {
          data,
          offset,
          limit
      }
    };
    return action;
  };
  
  export const fetchCustomers = (offset, limit) => {
    return (dispatch) => {
      dispatch(setIsCustomersFetchStarted(true));
      // dispatch(setIsCustomersFetched(false));
      axios
        .get(
          `${baseUrl}/user/${getAccessToken().id}/customers?offset=${offset}&limit=${limit}`,
          {
            headers: {
              "Content-type": "application/json",
              "API-Token": getAccessToken().api_token,
            },
          }
        )
        .then(function (response) {
          const res = response.data;
          if (res.status === "error") {
            toast.error(res.message);
          }
          if (res.status === "success") {
            
            dispatch(fetchCustomersSuccess(res.data.customers, offset, limit));
            dispatch(setIsCustomersFetched(true));
          }
          dispatch(setIsCustomersFetchStarted(false));
        })
        .catch(function (error) {
          const res = error.response.data || {};
          if (res.status === "error") {
            toast.error(res.message);
          }
          dispatch(setIsCustomersFetchStarted(false));
          dispatch(setIsCustomersFetched(false));
        });
    };
  };
  


//   CANCEL SUBSCRIPTION API

export const setIsCancelSubscriptionStarted = (status) => {
    const action = {
      type: CANCEL_SUBSCRIPTION_STARTED,
      payload: {
        status,
      },
    };
    return action;
  };
  
  export const cancelSubscriptionSuccess = (data) => {
    const action = {
      type: CANCEL_SUBSCRIPTION_SUCCESS,
      payload: {
          data,
      }
    };
    return action;
  };
  
  export const cancelSubscription = (data) => {
    return (dispatch) => {
      dispatch(setIsCancelSubscriptionStarted(true));
      axios
        .post(
          `${baseUrl}/user/${getAccessToken().id}/subscription/cancel`, JSON.stringify(data), 
          {
            headers: {
              "Content-type": "application/json",
              "API-Token": getAccessToken().api_token,
            },
          }
        )
        .then(function (response) {
          const res = response.data;
          if (res.status === "error") {
            toast.error(res.message);
          }
          if (res.status === "success") {
            toast.success("Subscription cancelled successfully");
            dispatch(cancelSubscriptionSuccess(res.data.rCustomer));
          }
          dispatch(setIsCancelSubscriptionStarted(false));
        })
        .catch(function (error) {
        //   const res = error.response.data;
        //   if (res.status === "error") {
        //     toast.error(res.message);
        //   }
          dispatch(setIsCancelSubscriptionStarted(false));
        });
    };
  };
  


//   fetch invoices

export const setIsInvoicesFetchStarted = (status) => {
    const action = {
      type: FETCH_INVOICES_STARTED,
      payload: {
        status,
      },
    };
    return action;
  };
  
  export const fetchInvoicesSuccess = (data, offset, limit) => {
    const action = {
      type: FETCH_INVOICES_SUCCESS,
      payload: {
          data,
          offset,
          limit
      }
    };
    return action;
  };
  export const setIsInvoicesFetched = (status) => {
    const action = {
      type: INVOICES_FETCHED_STATUS,
      payload: {
        status,
      },
    };
    return action;
  };
  
  export const fetchInvoices = (starting_after, limit) => {
    return (dispatch) => {
      dispatch(setIsInvoicesFetchStarted(true));
      axios
        .get(
          `${baseUrl}/user/${getAccessToken().id}/invoices?starting_after=${starting_after}&limit=${limit}`,
          {
            headers: {
              "Content-type": "application/json",
              "API-Token": getAccessToken().api_token,
            },
          }
        )
        .then(function (response) {
          const res = response.data;
          if (res.status === "error") {
            toast.error(res.message);
          }
          if (res.status === "success") {
            
            // toast.success("Customers Fetched");
            
            dispatch(fetchInvoicesSuccess(res.data.invoices, starting_after, limit));
            dispatch(setIsInvoicesFetched(true))
          }
          dispatch(setIsInvoicesFetchStarted(false));
        })
        .catch(function (error) {
          const res = error.response.data || {};
          if (res.status === "error") {
            toast.error(res.message);
          }
          dispatch(setIsInvoicesFetchStarted(false));
        });
    };
  };